<div class="field field-textarea">
  @if (label) {
    <span class="label">{{label}}</span>
  }
  <textarea
    [class.error-field]="error"
    [value]="model"
    (input)="modelChange.emit($event.target.value)"
    (keyup.enter)="enter.emit()"
    [placeholder]="placeholder"
  ></textarea>
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>